import useTranslation from 'next-translate/useTranslation'

import Modal from '../../app/components/modal/Modal'
import useAppSelector from '../../../store/hooks/useAppSelector'
import { outletIsVisibleOutletChangeWarningModalSelector } from '../store/outletSelector'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { outletSetIsVisibleOutletChangeWarningModal } from '../store/outletSlice'
import Button from '../../app/components/Button'
import BodyText from '../../app/components/BodyText'
import {
  checkoutDeletePendingSelector,
  currentCheckoutOutletNameSelector,
} from '../../checkout/store/checkoutSelectors'
import { deleteCheckout } from '../../checkout/store/checkoutThunks'
import { productSelectedIdSelector } from '../../product/store/productSelectors'
import { setProductDetailsModalVisible } from '../../product/store/productSlice'
import useAppStore from '../../../store/hooks/useAppStore'
import { isPreOrderCheckoutSelector } from '../../preOrder/store/preOrderSelectors'
import { preOrderClearCheckout } from '../../preOrder/store/preOrderSlice'
import localStorageUtils from '../../app/utils/localStorageUtils'

import styles from './OutletChangeWarningModal.module.scss'

export default function OutletChangeWarningModal() {
  const store = useAppStore()
  const { t } = useTranslation('outlet')
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector(outletIsVisibleOutletChangeWarningModalSelector)
  const outletName = useAppSelector(currentCheckoutOutletNameSelector)
  const deletePending = useAppSelector(checkoutDeletePendingSelector)

  function handleOnClose() {
    dispatch(outletSetIsVisibleOutletChangeWarningModal(false))
  }

  async function handleOnPressStartNewOrder() {
    const selectedProductId = productSelectedIdSelector(store.getState())
    const isPreOrderCheckout = isPreOrderCheckoutSelector(store.getState())

    if (isPreOrderCheckout) {
      dispatch(preOrderClearCheckout())
      localStorageUtils.removeItem('cartMeta')
    } else {
      await dispatch(deleteCheckout())
    }

    dispatch(outletSetIsVisibleOutletChangeWarningModal(false))

    if (selectedProductId) {
      dispatch(setProductDetailsModalVisible(true))
    }
  }

  return (
    <Modal
      title={t('outletChangeWarningModal.title')}
      isOpen={isOpen}
      onClose={handleOnClose}
      mobileModalMode="bottom-sheet"
      className={styles.modal}
    >
      <div className={styles.modalBody}>
        <BodyText color="body-1">
          {t('outletChangeWarningModal.message', { outletName })}
        </BodyText>
      </div>
      <div className={styles.modalFooter}>
        <Button variant="secondary" onClick={handleOnClose}>
          {t('outletChangeWarningModal.keepExistingOrder')}
        </Button>
        <Button onClick={handleOnPressStartNewOrder} disabled={deletePending}>
          {t('outletChangeWarningModal.startNewOrder')}
        </Button>
      </div>
    </Modal>
  )
}
